<template>
	<sf-data-table
		ref="deptMngTable"
		:pageUnit="pagingInfo.pageUnit"
		:totalSize="pagingInfo.totalSize"
		paging
		:columns="columns"
		:rows="rows"
		fit="fit"
		height="50vh"
		:stripe="false"
		@changedPage="changedPage"
	>
	</sf-data-table>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/comm/commpopup/DeptMngPopup/store/helpers';

export default {
	props: { scrId: { type: String, default: '' } },
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.resultList;
		},
		columns() {
			return [
				{
					label: this.getMessage_('QWCC001154'), //부서코드
					prop: 'deptCd',
					highlight: true,
					clickEvent: this.clickDept
				},
				{
					label: this.getMessage_('QWCC001153'), //부서명
					prop: 'deptNm'
				}
			];
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		clickDept(row) {
			this.$emit('SelectRow', row);
		},
		async changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('Refresh');
		}
	}
};
</script>

<style></style>
